import { Form, Input, Button, Toast } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { t } from '../../i18n';
import { EyeInvisibleOutline } from 'antd-mobile-icons';
import { useState } from 'react';
import { showError } from 'utils/exceptionUtils';
import { hasPdaPermission, login, saveUserInfo } from 'utils/auth';
import { timeout } from 'utils/timeout';
import { PhoneInput } from 'components/PhoneInput';
import logo from '../../icons/svgs/logo.svg';

export default function PdaLoginPage() {
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const onFinish = async (values: { phone: { countryCode: number; phoneNumber: string }; password: string }) => {
    try {
      const result = await login(values.phone.countryCode, values.phone.phoneNumber, values.password);

      if (result.userInfo) {
        if (!hasPdaPermission(result.userInfo)) {
          showError({
            title: t('pda.LoginPage.error.title'),
            message: t('errors.permission.forbidden'),
          })
          return;
        }
        // 保存token到本地存储
        saveUserInfo(result.userInfo);
        // 显示成功提示
        Toast.show({
          icon: 'success',
          content: t('login.success'),
        });
        await timeout(2000);
        // 跳转到首页
        navigate('/pda/home');
      } else {
        showError({
          title: t('pda.LoginPage.error.title'),
          message: t('pda.LoginPage.error.message'),
        })
      }
    } catch (error) {
      showError({
        title: t('pda.LoginPage.error.title'),
        message: t('pda.LoginPage.error.message'),
      })
    }
  };

  return (
    <div className="p-2 flex flex-col gap-2 h-full">
      <div className='flex flex-col justify-between items-center gap-2 mt-4'>
        <img
          src={logo}
          alt="SwiftX Logo"
          className="w-[180px] min-w-[120px] h-auto mx-auto max-w-[60%]"
        />
      </div>
      <Form
        requiredMarkStyle="none"
        onFinish={onFinish}
        style={{
          "--border-bottom": "none",
          "--border-top": "none",
          "--border-inner": "none",
        }}
        footer={
          <Button block type="submit" color="primary" size="large">
            {t('pda.LoginPage.submit.label')}
          </Button>
        }
      >
        <Form.Item
          name="phone"
          rules={[{ required: true }]}
        >
          <PhoneInput
            placeholder={t('pda.LoginPage.phone.placeholder')}
            size="large" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true }]}
        >
          <div className="border rounded-lg p-2 flex justify-between items-center">
            <Input
              type={isPasswordVisible ? 'text' : 'password'}
              placeholder={t('pda.LoginPage.password.placeholder')}
            />
            <EyeInvisibleOutline onClick={() => setIsPasswordVisible(!isPasswordVisible)} />
          </div>
        </Form.Item>
      </Form>
    </div>
  );
} 